import { Input } from 'antd';

import { Form } from 'common/components';

import { useFactPanelQasRequiredFields } from '../../../hook/useFactPanelQasRequiredFields';
import { QaSpecHelpContentWithoutLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';

const InactiveIngredients = ({ productId, typeView }) => {
  const { getRequiredRule } = useFactPanelQasRequiredFields({
    productId,
    typeView,
    section: 'qaSpecification.factsPanel.drugFactsLabel',
  });

  const isQaSpec = typeView === 'qa-spec';

  return (
    <Form.Item
      name='inactiveIngredients'
      style={{ marginTop: 8 }}
      rules={[
        getRequiredRule({
          fieldName: ['inactiveIngredients', 'inactiveIngredients'],
          displayName: 'Inactive Ingredients is required',
        }),
      ]}
    >
      {/* TODO: Can not update form value */}
      <QaSpecHelpContentWithoutLabel
        fieldPath={TOOlTIP_FIELDS.inactiveIngredients.fieldPath}
        isEnabled={isQaSpec}
      >
        <Input.TextArea rows={3} />
      </QaSpecHelpContentWithoutLabel>
    </Form.Item>
  );
};

export default InactiveIngredients;
